import Swal from 'sweetalert2';
import i18next from 'i18next';
import Backend from 'i18next-http-backend';
import storeLocale from './i18n/store.json';
import {getCookie, swalError, swalSuccessNoButton} from "./core";

class Store {
    // Store clain
    claim(){
        let $button = $('#store-claim');
        $button.click(() => {
            let reward = $('#reward').val();
            let title = $('#title').val();
            let description = $('#description').val();
            let points = $('#points').val();
            let locale = getCookie('language-js');
            locale = (locale === null || locale === '') ? 'en_US' : locale;

            i18next.use(Backend)
                .init({
                    lng: locale,
                    resources: storeLocale
                });

            Swal.fire({
                title: title,
                html: description + ' <strong style="color: #ff7600; font-weight: 600;">(' + points + ')</strong>.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#ff7600',
                cancelButtonColor: '#999',
                confirmButtonText: i18next.t('claim'),
                cancelButtonText: i18next.t('cancel')
            }).then((result) => {
                if (result.value) {
                    $.ajax({
                        url: $('#store-claim').data('route'),
                        type: 'post',
                        data: {
                            reward
                        }
                    }).done(function(json) {
                        swalSuccessNoButton(json);
                        setTimeout(() => window.location.reload(), 1000);

                    }).fail(function(json) {
                        swalError(json);
                    });
                }
            });

        });
    }
}
window.Store = Store;